module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-modal', {
    attrs: {
      "show": _vm.show
    },
    on: {
      "update:show": function($event) {
        _vm.show = $event
      }
    }
  }, [_c('p', [_vm._v("自定义弹框内容自定义弹框内容自定义弹框内容自定义弹框内容自定义弹框内容自定义弹框内容自定义弹框内容")])]), _c('vbl-modal', {
    attrs: {
      "show": _vm.show1,
      "vertical-center": ""
    },
    on: {
      "update:show": function($event) {
        _vm.show1 = $event
      }
    }
  }, [_c('p', [_vm._v("自定义弹框内容自定义弹框内容自定义弹框内容自定义弹框内容自定义弹框内容自定义弹框内容自定义弹框内容")])]), _c('vbl-button', {
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_vm._v("显示弹框")]), _c('br'), _c('br'), _c('vbl-button', {
    on: {
      "click": function($event) {
        _vm.show1 = true
      }
    }
  }, [_vm._v("显示垂直居中弹框")]), _c('br'), _c('br'), _c('vbl-button', {
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v("动态调用图片弹框")]), _c('br'), _c('br'), _c('vbl-button', {
    on: {
      "click": _vm.showConfirm
    }
  }, [_vm._v("动态调用确认弹框")]), _c('br'), _c('br'), _c('vbl-button', {
    on: {
      "click": _vm.showAlert
    }
  }, [_vm._v("动态调用提示弹框")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23054cb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblModal/example/vblModalExample.vue
// module id = 248
// module chunks = 0